export function TaskTimeSpent() {
  // TODO: To be implemented when integrating the TaskEditor component into ClientCard
}

export default TaskTimeSpent;
